import ToggleButtonGroup, {
  ToggleOption,
} from '../../../../components/Forms/Buttons/ToggleButtonGroup';
import SearchInputField from '../../../../components/Forms/Input/SearchInputField';
import SelectField from '../../../../components/Forms/Input/SelectField';

import {
  InventoryCategoryOption,
  InventoryViewFilter,
} from '../types';

interface InventoryFiltersProps {
  search: string;
  categoryId: number;
  viewFilter: InventoryViewFilter;
  categories: InventoryCategoryOption[];
  onSearchChange: (value: string) => void;
  onCategoryChange: (categoryId: number) => void;
  onViewChange: (value: InventoryViewFilter) => void;
}

const viewOptions = [
  {
    value: 'ALL',
    label: 'Todos',
  },
  {
    value: 'ACTIVE',
    label: 'Activos',
  },
  {
    value: 'LOW',
    label: 'Stock bajo',
  },
] satisfies ToggleOption<InventoryViewFilter>[];

const InventoryFilters = ({
  search,
  categoryId,
  viewFilter,
  categories,
  onSearchChange,
  onCategoryChange,
  onViewChange,
}: InventoryFiltersProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 border-b border-stroke p-5 dark:border-strokedark sm:px-7 lg:grid-cols-[minmax(260px,1fr)_260px_auto] lg:items-end">
      <div className="lg:pb-5">
        <SearchInputField
          label="Buscar"
          name="inventorySearch"
          value={search}
          iconKey="search"
          placeholder="Buscar materia prima o código..."
          withMargin={false}
          onChange={(event) =>
            onSearchChange(event.target.value)
          }
        />
      </div>

      <SelectField
        label="Categoría"
        name="inventoryCategory"
        value={categoryId}
        iconKey="category"
        options={[
          {
            value: 0,
            label: 'Todas las categorías',
          },
          ...categories.map((category) => ({
            value: category.id,
            label: category.name,
          })),
        ]}
        onChange={(event) =>
          onCategoryChange(Number(event.target.value))
        }
      />

      <ToggleButtonGroup
        value={viewFilter}
        options={viewOptions}
        onChange={onViewChange}
        className="mb-5"
      />
    </div>
  );
};

export default InventoryFilters;
